// Source: app/scripts/directives/uploadPanelMinio.js
Auction.directive('uploadPanelMinio', [
  "$upload",
  "Attachment",
  "toaster",
  '$modal',
  '$filter',
  'Downloader',
  '$window',
  function ($upload, Attachment, toaster, $modal, $filter, Downloader, $window) {
    return {
      restrict: 'E',
      transclude: false,
      scope: {
        objectId: "=",
        bean: "@",
        label: "@",
        accept: '@',
        data: '=',
        disabled: '=',
        edit: '=',
        exposeContainer: '=',
        hideDelete: '='
      },
      templateUrl: 'templates/upload-minio-file.html',
      link: function (scope, element, attrs, ctrl, transclude, formCtrl) {

         console.log('vo direktivata dto = ');
        // console.log(dto);
        console.log('vo direktivata scope.dto = ');

        console.log('vo direktivata scope = ');
        console.log(scope);

        scope.reload = function () {
          scope.attachments = Attachment.getAttachmentsByObjectId({
            id: scope.objectId,
            bean: scope.bean
          });
        };

        if (scope.objectId) {
          scope.reload();
        }


        var modalDeleteAttachment = $modal({
          scope: scope,
          template: '/templates/modal-form-notitle.tpl.html',
          contentTemplate: '/templates/delete-attachment.html',
          show: false
        });

        scope.deleteAttachmentDialog = function (id, bean) {
          scope.attachmentId = id;
          scope.bean = bean;
          modalDeleteAttachment.show();
        };

        scope.deleteAttachment = function (id, bean) {
          Attachment.deleteAttachment({
            id: scope.attachmentId,
            bean: scope.bean
          }, function () {
            scope.reload();
            modalDeleteAttachment.hide();
          });
        };

        function endsWith(str, end) {
          return (str.indexOf(end) + end.length) == str.length;
        }

        scope.extensions = scope.accept && scope.accept.split(',');

        scope.download = function (id) {
          Downloader.download('/data/rest/attachments/' + id);
        };

        scope.onFileSelect = function ($files) {
          if (scope.disabled) {
            return;
          }
          scope.files = $files;

          function onSuccess(data, status, headers, config) {
            console.log("vo uploadPanelMinio.js success 1");
            toaster.pop('success', $filter('translate')('generic.success'),
              $filter('translate')('action.saved'));
            scope.reload();
          }

          function onError(data, status, headers, config) {
            toaster.pop('error', $filter('translate')('generic.error'),
              $filter('translate')('Upload failed'));
          }

          for (var i = 0; i < $files.length; i++) {

            var file = $files[i];

            var containsExtension = true;
            if (scope.extensions) {
              containsExtension = false;
              angular.forEach(scope.extensions, function (e) {
                if (endsWith(file.name, e)) {
                  containsExtension = true;
                }
              })
            }
            if (!containsExtension) {
              scope.files = [];
              toaster.pop('error', $filter('translate')('generic.error'),
                $filter('translate')('action.invalid_extension'));
              return;
            }



          }
        };

        if (scope.exposeContainer) {
          scope.exposeContainer.scope = scope;
        }


        scope.done = function () {
          for (var i = 0; i < scope.files.length; i++) {
            var file = scope.files[i];
            scope.upload = $upload.upload({
              url: "/data/rest/portal_attachments/"  + scope.bean + "/" +  scope.objectId,
              data: scope.data,
              file: file

            }).success(onSuccess).error(onError);
          }

          function onSuccess(data, status, headers, config) {
            console.log("vo uploadPanelMinio.js success");
            toaster.pop('success', $filter('translate')('generic.success'),
              $filter('translate')('action.saved'));
            scope.reload();
            $window.location.reload();
          }

          function onError(data, status, headers, config) {
            toaster.pop('error', $filter('translate')('generic.error'),
              $filter('translate')('Upload failed'));
          }

        }

      }
    };
  }
]);
